import { getUUID } from "@/lib/uuid/get-uuid";

import type { FormOptionType } from "../_types/type";

export const UnselectedFormOptionItem: FormOptionType = {
	id: getUUID(),
	label: "未設定",
	value: null as unknown as string,
};
